import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * A translucent marketing pill, used on the walkthrough's pane 1 foot and — via
 * `WalkthroughModule`'s export — on Login's and Signup's primary pitch column.
 *
 * Ported from koomzodesignsystem `features/auth/components/auth-pitch-pill`
 * (kz2 F1).
 *
 * ---------------------------------------------------------------------------
 * DELIBERATELY NOT a status badge.
 *
 * A status badge's vocabulary is STATUS — `LOW`, `OUT`, `LOCKED` — and its
 * tones map to semantic colours a user learns to read across the workspace.
 * `Offline by design` is a claim, not a state. The two objects look alike and
 * mean different things; merging them would put marketing copy into the tone
 * vocabulary and cost the badge the precision that makes it useful.
 * ---------------------------------------------------------------------------
 *
 * Content is projected, so the caller owns the copy and its translation.
 */
@Component({
  selector: 'app-auth-pitch-pill',
  standalone: false,
  templateUrl: './auth-pitch-pill.component.html',
  styleUrls: ['./auth-pitch-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthPitchPillComponent {
  /** Ionicons name, verbatim from the source. */
  @Input() icon = '';
}
